/** BioBellinda France Instagram highlights player – self-hosted Shopify media only. */
(() => {
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches || false;
  function setup(root) {
    root.querySelectorAll('[data-bbf-instagram]').forEach(widget => {
      if (widget.dataset.bbfInstagramReady) return;
      widget.dataset.bbfInstagramReady = 'true';
      const launcher = widget.querySelector('[data-bbf-ig-toggle]');
      const modal = widget.querySelector('[data-bbf-ig-dialog]');
      const backdrop = widget.querySelector('[data-bbf-ig-backdrop]');
      const close = widget.querySelector('[data-bbf-ig-close]');
      const home = widget.querySelector('[data-bbf-ig-home]');
      const viewer = widget.querySelector('[data-bbf-ig-viewer]');
      const stage = widget.querySelector('[data-bbf-ig-stage]');
      const progress = widget.querySelector('[data-bbf-ig-progress]');
      const title = widget.querySelector('[data-bbf-ig-story-title]');
      const caption = widget.querySelector('[data-bbf-ig-story-caption]');
      const storyLink = widget.querySelector('[data-bbf-ig-story-link]');
      const stories = [...widget.querySelectorAll('[data-bbf-ig-story-open]')];
      let current = -1;
      let timer = null;
      let priorFocus = null;
      let swipeX = null;

      const clearPlayback = () => {
        window.clearTimeout(timer);
        timer = null;
        stage.querySelectorAll('video').forEach(v => { v.pause(); v.removeAttribute('autoplay'); });
        stage.replaceChildren();
      };
      const back = () => {
        clearPlayback();
        current = -1;
        viewer.hidden = true;
        home.hidden = false;
        const first = home.querySelector('[data-bbf-ig-story-open]');
        (first || close).focus({preventScroll:true});
      };
      const hide = () => {
        clearPlayback();
        modal.hidden = true;
        backdrop.hidden = true;
        viewer.hidden = true;
        home.hidden = false;
        current = -1;
        launcher.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('bbf-ig-modal-open');
        (priorFocus && priorFocus.isConnected ? priorFocus : launcher).focus({preventScroll:true});
      };
      const show = () => {
        priorFocus = document.activeElement;
        modal.hidden = false;
        backdrop.hidden = false;
        launcher.setAttribute('aria-expanded', 'true');
        document.body.classList.add('bbf-ig-modal-open');
        close.focus({preventScroll:true});
      };
      const renderStory = index => {
        if (!stories.length) return;
        clearPlayback();
        current = (index + stories.length) % stories.length;
        const button = stories[current];
        const container = button.closest('.bbf-ig-highlight');
        const tpl = container?.querySelector('[data-bbf-ig-media]');
        if (!tpl) return;
        home.hidden = true;
        viewer.hidden = false;
        stage.appendChild(tpl.content.cloneNode(true));
        title.textContent = container.querySelector('.bbf-ig-highlight__name')?.textContent?.trim() || 'BioBellinda France';
        caption.textContent = container.querySelector('[data-bbf-ig-caption]')?.textContent?.trim() || '';
        storyLink.href = container.querySelector('[data-bbf-ig-url]')?.textContent?.trim() || 'https://www.instagram.com/biobellinda.bio.france/';
        progress.replaceChildren();
        stories.forEach((_, i) => {
          const bar = document.createElement('span');
          if (i < current) bar.classList.add('is-done');
          if (i === current) bar.classList.add('is-playing');
          progress.appendChild(bar);
        });
        const video = stage.querySelector('video');
        const duration = 6500;
        if (video) {
          video.playsInline = true;
          video.muted = true;
          video.controls = true;
          const setDuration = () => {
            if (Number.isFinite(video.duration) && video.duration > 0) {
              progress.style.setProperty('--bbf-story-duration', `${video.duration}s`);
            } else {
              progress.style.setProperty('--bbf-story-duration', '30s');
            }
          };
          setDuration();
          video.addEventListener('loadedmetadata', setDuration, {once:true});
          video.addEventListener('ended', () => renderStory(current + 1), {once:true});
          if (!reduceMotion) video.play().catch(() => {});
        } else if (!reduceMotion) {
          progress.style.setProperty('--bbf-story-duration', `${duration}ms`);
          timer = window.setTimeout(() => renderStory(current + 1), duration);
        }
        widget.querySelector('[data-bbf-ig-back]')?.focus({preventScroll:true});
      };
      launcher.addEventListener('click', () => modal.hidden ? show() : hide());
      close.addEventListener('click', hide);
      backdrop.addEventListener('click', hide);
      widget.querySelectorAll('[data-bbf-ig-back]').forEach(b => b.addEventListener('click', back));
      widget.querySelector('[data-bbf-ig-next]').addEventListener('click', () => renderStory(current + 1));
      widget.querySelector('[data-bbf-ig-prev]').addEventListener('click', () => renderStory(current - 1));
      stories.forEach((button, i) => button.addEventListener('click', () => renderStory(i)));
      stage.addEventListener('touchstart', e => { swipeX = e.changedTouches[0]?.screenX ?? null; }, {passive:true});
      stage.addEventListener('touchend', e => {
        if (swipeX === null) return;
        const distance = (e.changedTouches[0]?.screenX ?? swipeX) - swipeX;
        swipeX = null;
        if (Math.abs(distance) > 55) renderStory(current + (distance < 0 ? 1 : -1));
      }, {passive:true});
      modal.addEventListener('keydown', e => {
        if (e.key === 'Escape') { e.preventDefault(); hide(); return; }
        if (e.key === 'ArrowRight' && !viewer.hidden) { e.preventDefault(); renderStory(current + 1); }
        if (e.key === 'ArrowLeft' && !viewer.hidden) { e.preventDefault(); renderStory(current - 1); }
        if (e.key !== 'Tab') return;
        const focusable = [...modal.querySelectorAll('a[href],button:not([disabled])')]
          .filter(el => !el.closest('[hidden]') && el.getClientRects().length);
        if (!focusable.length) return;
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      document.addEventListener('shopify:section:unload', e => {
        if (e.target.contains(widget) && !modal.hidden) hide();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document), {once:true});
  else setup(document);
  document.addEventListener('shopify:section:load', e => setup(e.target));
})();
